// mds-dojo — dijit/form/_FormWidget — FAITHFUL port of
// references/dijit/form/_FormWidget.js. Codemod pipeline; declare from the faithful
// runtime. Adaptations: `dojo/sniff` → `dojo/has`; the `dijit-legacy-requires`
// ready()/require() back-compat block removed (no AMD loader under Vite); `dojo/ready`
// import dropped with it; `kernel.deprecated` is shimmed to a no-op when the slim
// mds kernel lacks it (deprecation warnings are non-functional; the method still works).
// Base class for widgets corresponding to native HTML elements such as <checkbox> or
// <button>, which can be children of a <form> node or a dijit/form/Form widget.
import declare from '../../dojo/_base/declare-runtime'; // declare
import has from '../../dojo/has'; // has("msapp")
import kernel from '../../dojo/_base/kernel'; // kernel.deprecated
import _Widget from '../_Widget';
import _CssStateMixin from '../_CssStateMixin';
import _TemplatedMixin from '../_TemplatedMixin';
import _FormWidgetMixin from './_FormWidgetMixin';

var deprecated: any = (kernel as any).deprecated || function () { /* no-op shim */ };

export default declare("dijit.form._FormWidget", [_Widget, _TemplatedMixin, _CssStateMixin, _FormWidgetMixin], {
	// summary:
	//		Base class for widgets corresponding to native HTML elements such as `<checkbox>` or `<button>`,
	//		which can be children of a `<form>` node or a `dijit/form/Form` widget.

	setDisabled: function (/*Boolean*/ disabled: any) {
		// summary:
		//		Deprecated.  Use set('disabled', ...) instead.
		deprecated("setDisabled(" + disabled + ") is deprecated. Use set('disabled'," + disabled + ") instead.", "", "2.0");
		this.set('disabled', disabled);
	},

	setValue: function (/*String*/ value: any) {
		// summary:
		//		Deprecated.  Use set('value', ...) instead.
		deprecated("dijit.form._FormWidget:setValue(" + value + ") is deprecated.  Use set('value'," + value + ") instead.", "", "2.0");
		this.set('value', value);
	},

	getValue: function () {
		// summary:
		//		Deprecated.  Use get('value') instead.
		deprecated(this.declaredClass + "::getValue() is deprecated. Use get('value') instead.", "", "2.0");
		return this.get('value');
	},

	postMixInProperties: function () {
		// Setup name=foo string to be referenced from the template (but only if a name has been specified).
		// Regarding escaping, see heading "Attribute values" in
		// http://www.w3.org/TR/REC-html40/appendix/notes.html#h-B.3.2
		this.nameAttrSetting = (this.name && !has("msapp")) ? ('name="' + this.name.replace(/"/g, "&quot;") + '"') : '';
		this.inherited(arguments);
	}
});
